import dayjs from '@tt/dates/dayjs';

const EXECUTION_WALL_CLOCK = 'YYYY-MM-DD HH:mm:ss';

// Beautified execution dates are broker wall-clock strings with no offset.
// Parse them in the broker zone so the chart window stays inside the session.
const executionUnixSeconds = (date, timezone) =>
    dayjs.tz(date, EXECUTION_WALL_CLOCK, timezone || 'America/New_York').unix();

export default executionUnixSeconds;
